"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRopstenCatalysts = exports.getMainnetCatalysts = void 0;

var CatalystContract_1 = require("../contracts/CatalystContract");

function getMainnetCatalysts() {
  return getServersFromNetwork('mainnet');
}

exports.getMainnetCatalysts = getMainnetCatalysts;

function getRopstenCatalysts() {
  return getServersFromNetwork('ropsten');
}

exports.getRopstenCatalysts = getRopstenCatalysts;

function getServersFromNetwork(_x) {
  return _getServersFromNetwork.apply(this, arguments);
}
/**
 * Converts the data from the contract into something more useful.
 * Returns undefined if the data from the contract is invalid.
 */


function _getServersFromNetwork() {
  _getServersFromNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(network) {
    var contract, count, indices, dataPromises, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contract = CatalystContract_1.DAOContract.withNetwork(network); // Check count on the list

            _context.next = 3;
            return contract.getCount();

          case 3:
            count = _context.sent;
            // Create an array with values from 0 to count - 1
            indices = new Array(count).fill(0).map(function (_, i) {
              return i;
            }); // Fetch data from the contract

            dataPromises = indices.map(function (index) {
              return contract.getCatalystIdByIndex(index).then(function (id) {
                return contract.getServerData(id);
              });
            });
            _context.next = 8;
            return Promise.all(dataPromises);

          case 8:
            data = _context.sent;
            return _context.abrupt("return", data.map(toMetadata).filter(function (metadata) {
              return !!metadata;
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getServersFromNetwork.apply(this, arguments);
}

function toMetadata(data) {
  var id = data.id,
      owner = data.owner,
      domain = data.domain;
  var address = domain.trim();

  if (address.startsWith('http://')) {
    console.warn("Catalyst node domain using http protocol, skipping ".concat(address));
    return undefined;
  }

  if (!address.startsWith('https://')) {
    address = 'https://' + address;
  }

  return {
    address: address,
    owner: owner,
    id: id
  };
}